import Tracker from '@framework/analytics-tracker/Tracker';
import { inject, injectable } from 'inversify';
import { Subscription } from '@dealroadshow/socket-frontend-sdk';
import Request from '@framework/api/Rpc/Request';
import { SocketClient, type ISocketClientFactory } from '@dataroom/socket-client';

@injectable()
class DataroomTracker extends Tracker {
  private subscription: Subscription | null = null;

  constructor(
    @inject(SocketClient) private readonly socketClient: ISocketClientFactory,
  ) {
    super();
  }

  start = async (
    payload: {
      dataroomId: number,
      userId: number,
    },
  ): Promise<void> => {
    const { dataroomId, userId } = payload;
    const subscribeReq = new Request('dataroom.time_tracking.listen', { dataroomId, userId });

    this.subscription = await this.socketClient().subscribe<Subscription>(subscribeReq);
  };

  stop() {
    if (this.subscription instanceof Subscription) {
      this.subscription.cancel();
    }
  }

  track = async (
    payload: {
      dataroomId: number,
      userId: number,
    },
  ): Promise<void> => {
    const { dataroomId, userId } = payload;
    const pingPayload = new Request('dataroom.websocket.ping', { dataroomId, userId });

    await this.socketClient().rpc.call(pingPayload);
  };
}

export default DataroomTracker;
